import QmStatisticOutlet from './qm-statistic.outlet';
export default QmStatisticOutlet;
